<template>
    <div v-if="props.matchedProjectData" class="medium-padding">
        <p><primeview-button @click="openProjectInModal" text>{{ matchedProjectData?.projectName }}</primeview-button></p>
        <p v-if="props.potentialMatchMetadata.projectIsAMatchAccordingToAi">PROJECT IS A MATCH ACCORDING TO AI</p>
        <p>{{ props.potentialMatchMetadata.distance }}</p>
        <p>{{ props.potentialMatchMetadata.scoredMatchInfo.explanation }}</p>
        <p>{{ props.potentialMatchMetadata.scoredMatchInfo.aiReasoning }}</p>
        <primeview-button class="plain-btn" @click="confirmMatch">Confirm match</primeview-button>
    </div>
</template>

<script lang="ts" setup>
import { PotentialMatch } from '@/interfaces/storageTracking/IArticle.ts';
import { IRedactedProjectData } from '@/interfaces/storageTracking/IRedactedProjectData.ts';
import PrimeviewButton from 'primevue/button';

const props = defineProps<{
    matchedProjectData: IRedactedProjectData | null;
    potentialMatchMetadata: PotentialMatch;
}>();

const emit = defineEmits<{
    'open-project-in-modal': [IRedactedProjectData | null];
    'confirm-match': [IRedactedProjectData];
}>();

function openProjectInModal (): void {
    emit('open-project-in-modal', props.matchedProjectData);
}

function confirmMatch (): void {
    if (!props.matchedProjectData) return;
    emit('confirm-match', props.matchedProjectData);
}

</script>
